export default "<span class=\"material-icons\" (click)=\"onClick($event)\">\n    clear\n</span>";